import { Helmet } from 'react-helmet'
import PasswordStrengthBackground from './PasswordStrengthBackground'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Password Strength Background</title>
    </Helmet>
    <PasswordStrengthBackground />
  </>
)
export default Wrapper
